import { useEffect, useRef, useState } from "react";
import { Loader2, Search } from "lucide-react";
import { api } from "@/lib/api";

export const SearchBox = ({ onPick }) => {
  const [q, setQ] = useState(""); const [items, setItems] = useState([]); const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false); const [active, setActive] = useState(0); const box = useRef(null);
  useEffect(() => {
    if (!q.trim()) { setItems([]); return undefined; }
    const id = setTimeout(async () => { setBusy(true); try { setItems(await api.search(q.trim())); setActive(0); } catch { setItems([]); } setBusy(false); }, 250);
    return () => clearTimeout(id);
  }, [q]);
  useEffect(() => { const h = e => !box.current?.contains(e.target) && setOpen(false); document.addEventListener("pointerdown", h); return () => document.removeEventListener("pointerdown", h); }, []);
  const pick = item => { onPick(item.symbol); setQ(""); setOpen(false); };
  const onKey = e => {
    if (e.key === "ArrowDown") setActive(a => Math.min(a + 1, items.length - 1));
    if (e.key === "ArrowUp") setActive(a => Math.max(a - 1, 0));
    if (e.key === "Enter" && items[active]) pick(items[active]);
    if (e.key === "Escape") setOpen(false);
  };
  return <div className="search" ref={box}>
    {busy ? <Loader2 size={16} className="spin" /> : <Search size={16} />}
    <input data-testid="stock-search-input" placeholder="Search any NSE stock to buy or sell…" value={q} onFocus={() => setOpen(true)} onKeyDown={onKey} onChange={e => { setQ(e.target.value); setOpen(true); }} />
    {open && q.trim() && <div className="search-results" data-testid="stock-search-results">
      {items.length === 0 && !busy && <div className="search-empty">No NSE stocks found</div>}
      {items.map((it, i) => <button key={it.symbol} className={`search-item ${i === active ? "active" : ""}`} data-testid={`search-result-${it.symbol.toLowerCase()}`} onMouseEnter={() => setActive(i)} onClick={() => pick(it)}>
        <b>{it.symbol}</b><span>{it.name}</span><em>NSE</em>
      </button>)}
    </div>}
  </div>;
};
